import {DrawerNavigationCategoryTree_TreeItem} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/drawer_navigation.types';
import {CategoryTile, SaleCloudIcon} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {CouponHintIcon} from '../../../../features/Coupons/CouponHintIcon/CouponHintIcon';
import {normalizeThumbnail} from './normalizeThumbnail';

export const CategoryTreeNavigationItem = ({
  item,
  shouldReduceTextSize,
}: {
  item: DrawerNavigationCategoryTree_TreeItem;
  shouldReduceTextSize?: boolean;
}) => {
  const cloudIconColor = (() => {
    if (item.reductionType?.$case === 'discountReduction') {
      return item.reductionType.discountReduction.color.hex;
    }

    if (item.saleIcon) {
      return item.saleIcon.color.hex;
    }

    return '';
  })();

  return (
    <CategoryTile
      labelSize={shouldReduceTextSize ? 'px12' : 'px16'}
      thumbnail={normalizeThumbnail({categoryPreview: item.categoryPreview})}
      label={item.category.name}
      iconComponent={
        <>
          {(item.reductionType?.$case === 'discountReduction' ||
            item.saleIcon) && (
            <StyledSaleCloudIcon
              data-testid="saleIcon"
              colors={[cloudIconColor]}
            />
          )}
          {item.reductionType?.$case === 'couponReduction' && (
            <CouponHintIcon data-testid="couponHintIcon" />
          )}
        </>
      }
    />
  );
};

const StyledSaleCloudIcon = styled(SaleCloudIcon)`
  && {
    left: -23px;
    top: -23px;
    max-width: 50px;
  }
`;
